<script lang="ts" setup>
  import { ref } from 'vue';
  import { useSubmitState } from "../../composables/use-form-services.js";
  import { useFormSubmit } from '../../composables/use-form-submit.js';
  import { isNil } from '@mcwd/typescript-type-guards';
  import loader from './loader-icon.vue';

  const { submitState } = useSubmitState({ callerLabel: "resource-form-full-gate.vue" });
  const emit = defineEmits< (e: 'submitForm') => void >();
  const submitButtonRef = ref< HTMLButtonElement | null >(null);
  const btnSpinner = ref(false);
  const { errorCheck } = useFormSubmit();

  function showSubmitSpinner() {
    btnSpinner.value = true;
    setTimeout(() => {
      emit('submitForm');
      if(submitState.totalErrors > 0) {
        btnSpinner.value = false;
      }
    }, 500);
  }

  function submitButtonHover() {
    if (isNil(submitButtonRef.value)){
      throw new Error("Submit Button Ref does not exist!");
    }
    submitButtonRef.value.focus();
    errorCheck();
  }
</script>

<template>
  <button 
    ref="submitButtonRef"
    type="button"
    class="btn-mkto-submit"
    role="button"
    :class="{'ready': submitState.totalDoneRequired }"
    @mouseover="submitButtonHover"
    @click="$event => showSubmitSpinner()"
  >
    <loader :class="{active: btnSpinner}" />

    <slot>
      Submit Form    <!--fall back when slot is not passed-->
    </slot>   
  </button>
</template>
